<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from '@vue/reactivity';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const route = inject('route');

const companyName = computed(() => usePage().props.company_details.company_name);
const bottomRight = computed(() => usePage().props.template_options.footer.footer_bottom_right);
</script>

<template>
    <div class="h-10 text-sm bg-gray-darker text-gray-light md:h-10">
        <div class="container flex items-center h-full">
            <div class="flex justify-between w-full gap-4">
                <p v-if="companyName" v-html="`${companyName} © ${new Date().getFullYear()}`"></p>

                <div v-html="bottomRight"></div>
            </div>
        </div>
    </div>
</template>
